import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-flexbox-grid';
import {
  Icons,
  Icon,
  Button,
  styled,
  Pagination,
  Select,
  MenuItem,
} from '@nextiva/next-ui-components';
import { IsActionPermitted } from 'containers/withPermissions';
import styles from './TableActionsPanel.scss';

const StyledSelect = styled(Select)`
  margin: 0 5px;
`;
const pagesOptions = [10, 20, 50, 100];
const StyledCreateButton = styled(Button)`
  min-width: 36px;
  height: 32px;
  padding: 0;
  background-color: #93cd4c;
  &.MuiButton-text.MuiButton-textPrimary:hover {
    background-color: #93cd4c;
  }
`;
const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;
class TableActionsPanel extends Component {
  render() {
    const {
      createLink, // create link
      onChangeLimit,
      defaultLimit, // change page size
      pageCount,
      onPageChange, // change page number
      permissions = [], // create button permissions
    } = this.props;

    const limit = { value: defaultLimit, label: defaultLimit };
    return (
      <Row className={styles.tableActionsPanel}>
        {onChangeLimit && (
          <Col xs>
            <div className={styles.leftPanel}>
              <span className={styles.text}>Show</span>
              <StyledSelect
                id="tableAction"
                value={limit.value}
                placeholder={limit.value}
                onChange={this.props.onChangeLimit}
                defaultValue={defaultLimit}
                data-testid="PlatformAdminUI-TableActionsPanel-Select"
              >
                {pagesOptions.map((value) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </StyledSelect>
              <span className={styles.text}>entries</span>
            </div>
          </Col>
        )}

        <Col xs className={styles.rightPanel}>
          <div className={styles.innerContainer}>
            {createLink && (
              <div className={styles.rightInnerBlock}>
                <IsActionPermitted permissions={permissions}>
                  {(isPermitted) => (
                    <Link
                      to={isPermitted ? createLink : ''}
                      data-testid="PlatformAdminUI-TableActionsPanel-Link"
                    >
                      <StyledCreateButton disabled={!isPermitted}>
                        <StyledIcon icon={Icons.add} />
                      </StyledCreateButton>
                    </Link>
                  )}
                </IsActionPermitted>
              </div>
            )}
            {onPageChange && (
              <div className={styles.rightInnerBlock}>
                <Pagination
                  count={pageCount}
                  hideNextButton
                  hidePrevButton
                  onChange={onPageChange}
                  data-testid="PlatformAdminUI-TableActionsPanel-Pagination"
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

export default TableActionsPanel;
